import {Component} from 'react';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
  return {
    user: state.user,
    errorMessage: state.errorMessage,
  }
}

class Welcome extends Component {

  render() {
    return null
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.user.account_id) {
      this.props.history.replace(prevProps.to);
    }
  }
};


export default connect(mapStateToProps)(Welcome);




// WEBPACK FOOTER //
// ./src/welcome.jsx